import { selectIsSystemCheckCompleted } from "modules/systemCheck/redux/selectors";
import { useSelector } from "react-redux";
import { EventPrechecks, PrecheckStatus } from "../constants";
import { PrecheckResult } from "../types";

export const useSystemCheck = (): PrecheckResult => {
  const isSystemCheckCompleted = useSelector(selectIsSystemCheckCompleted);
  return {
    name: EventPrechecks.MIC_CAM_CHECK,
    status: isSystemCheckCompleted ? PrecheckStatus.PASS : PrecheckStatus.FAIL,
  };
};
